module.exports = __webpack_public_path__ + "static/img/knowleage-grid-background.27b9efdc.png";